module.exports = __webpack_public_path__ + "img/header_code2.11bec3f3.png";